import React, { useEffect, useRef, useState } from 'react';
import { ref, set } from "firebase/database";
import { auth, database } from '../../firebase';
import { createPerodioTimeString } from '../../utils/clockHelpers';
import styles from './timer.module.scss';
import { User, browserSessionPersistence, onAuthStateChanged, setPersistence, signInWithEmailAndPassword } from 'firebase/auth';

const Timer: React.FC = () => {

    const [ currentUser, setCurrentUser ] = useState<User | null>();
    const [ email, setEmail ] = useState<string>("");
    const [ password, setPassword ] = useState<string>("");
    
    const [ time, setTime ] = useState(0);
    const [ intervalId, setIntervalId ] = useState<NodeJS.Timer>();
    // Track total elapsed milliseconds in a ref so sub-second precision survives pause/resume
    const offsetMsRef = useRef<number>(0);
    const startedAtRef = useRef<number>(0);
    const [ newPeriod, setNewPeriod ] = useState(1);
    const [ period, setPeriod ] = useState(1);
    const [ newMinutes, setNewMinutes ] = useState(0);
    const [ newSecods, setNewSecods ] = useState(0);
    const [ homeGoals, setHomeGoals ] = useState<number>(0);
    const [ awayGoals, setAwayGoals ] = useState(0);

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            setCurrentUser(user);
        })
    }, []);

    const setNewTime = (minutes: number, seconds: number) => (minutes * 60) + seconds;

    const handleClick = () => {
        if (intervalId) {
            // Pause: freeze the accumulated ms so the sub-second offset is preserved
            offsetMsRef.current = Date.now() - startedAtRef.current + offsetMsRef.current;
            clearInterval(intervalId);
            setIntervalId(undefined);
            return;
        }

        // Resume: start wall-clock from now; elapsed = (now - startedAt) + offsetMs
        startedAtRef.current = Date.now();
        const newIntervalId = setInterval(() => {
            const totalMs = Date.now() - startedAtRef.current + offsetMsRef.current;
            setTime(Math.floor(totalMs / 1000));
        }, 100);
        setIntervalId(newIntervalId);
    };

    useEffect(() => {
        set(ref(database, 'clock'), {
            period,
            periodTime: time,
            fullTime: 0,
        });
    }, [time, period]);

    useEffect(() => {
        set(ref(database, 'home'), {
            name: 'SalBa',
            score: homeGoals,
            hasPenalty: false,
            penaltyTime: 0,
            timeoutHeld: false,
        });
    }, [homeGoals])

    useEffect(() => {
        set(ref(database, 'away'), {
            name: 'Karhut',
            score: awayGoals,
            hasPenalty: false,
            penaltyTime: 0,
            timeoutHeld: false,
        });
    }, [awayGoals])

    const login = () => {
        setPersistence(auth, browserSessionPersistence)
        .then(() => {
            return signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                setCurrentUser(user);
                // ...
            })
            .catch((error) => {
                console.log(error.code);
                console.log(error.message);
            });
        })
        
    }

    return currentUser?.uid ? (
        <div>
            <div className={styles.startTimerWrapper}>
                <div className={styles.startTimerButton}>
                    <button onClick={handleClick}>{intervalId === undefined ? 'Start clock' : 'Stop clock'}</button>
                </div>
                <div className={styles.startTimerTime}>
                    {createPerodioTimeString(time)}
                </div>
            </div>
            <div className={styles.setPeriodWrapper}>
                <div className={styles.setPeriodInput}>
                    <input type="text" name="period" onChange={(e) => setNewPeriod(+e.target.value)} />
                </div>
                <div className={styles.setPeriodButton}>
                    <button onClick={() => setPeriod(newPeriod)}>Set period</button>
                </div>
            </div>
            <div className={styles.setTimeWrapper}>
                <div className={styles.setTimeInputWrapper}>
                    <div className={styles.setTimeMinutes}>
                        <input type="text" name="clockMinutes" onChange={(e) => setNewMinutes(+e.target.value)}/>
                    </div>
                    <div className={styles.setTimeSeparator}>:</div>
                    <div className={styles.setTimeSeconds}>
                        <input type="text" name="clockSecods" onChange={(e) => setNewSecods(+e.target.value)}/>
                    </div>
                </div>
                <div className={styles.setTimeButton}>
                    <button onClick={() => {
                        const ms = setNewTime(newMinutes, newSecods) * 1000;
                        offsetMsRef.current = ms;
                        startedAtRef.current = Date.now();
                        setTime(setNewTime(newMinutes, newSecods));
                    }}>Set clock</button>
                </div>
            </div>
            <div>
                <div className={styles.goalsWrapper}>
                    <div className={styles.goalsTeamTitle}>
                        Home
                    </div>
                    <div className={styles.goalsValueWrapper}>
                        <div className={styles.goalsButton}>
                            <button onClick={() => setHomeGoals(homeGoals - 1)}>Reduce</button>
                        </div>
                        <div className={styles.goalsAmount}>
                            {homeGoals}
                        </div>
                        <div className={styles.goalsButton}>
                            <button onClick={() => setHomeGoals(homeGoals + 1)}>Add</button>
                        </div>
                    </div>
                </div>

                <div className={styles.goalsWrapper}>
                    <div className={styles.goalsTeamTitle}>
                        Away
                    </div>
                    <div className={styles.goalsValueWrapper}>
                        <div className={styles.goalsButton}>
                            <button onClick={() => setAwayGoals(awayGoals - 1)}>Reduce</button>
                        </div>
                        <div className={styles.goalsAmount}>
                            {awayGoals}
                        </div>
                        <div className={styles.goalsButton}>
                            <button onClick={() => setAwayGoals(awayGoals + 1)}>Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <div className={styles.loginForm}>
            <h2>Kirjaudu</h2>
            <legend>
                Sähköposti
                <input name="email" type="email" onChange={(e) => setEmail(e.target.value)} />
            </legend>
            <legend>
                Salasana
                <input name="password" type="password" onChange={(e) => setPassword(e.target.value)} />
            </legend>
            <button type="button" disabled={email === "" || password === "" } onClick={() => login()}>Kirjaudu</button>
        </div>
    );
};

export default Timer;
